<template>
    <div>
        <v-img src="smile-bg-2.png" class="white--text align-start full-page-primary homepage-header-bg-wrap" height="auto">
            <v-container class="mt-4">
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="12" lg="12">
                        <h1 class="text-center">Sexual Harassment Prevention Training & More</h1>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center" class="mt-4 text-center">
                    <v-col cols="12" sm="12" lg="10">
                        <p class="title">
                            ADP<sub class="overline">®</sub> BizPro is a video-based online education platform to help businesses stay in compliance with state-mandated training requirements and follow best practices in the workplace.
                        </p>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="12" lg="6" class="text-center">
                        <p class="headline font-weight-bold">ADP<sub class="overline">®</sub> Wholesale Partners Enjoy:</p>
                        <v-img src="25offretailbanner.png" />
                    </v-col>
                </v-row>
                <v-row align="center" justify="center" class="ma-5">
                    <v-col cols="12" sm="12" lg="6" class="text-center">
                        <v-btn color="green" dark x-large to="/register">Register Now</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-img>
        <v-container class="py-12">
            <v-row align="center" justify="center">
                <v-col cols="12" sm="12" lg="12">
                    <h1 class="font-weight-bold text-center">Help Your Clients Stay Compliant</h1>
                </v-col>
            </v-row>
            <v-row align="center" justify="center" class="mt-4">
                <v-col cols="12" sm="12" lg="4" v-for="compliance in compliances" :key="compliance.title">
                    <v-card min-height="220px">
                        <v-card-title class="font-weight-black subtitle-1">
                            {{ compliance.title }}
                        </v-card-title>
                        <v-card-text>
                            <ul class="fa-ul compliance">
                                <li v-for="item in compliance.items" :key="item">
                                    <span class="fa-li"><i class="fas fa-long-arrow-alt-right" :class="compliance.color"></i></span>
                                    {{ item }}
                                </li>
                            </ul>
                        </v-card-text>
                        <v-card-actions>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <v-row align="center" justify="center" class="pt-12">
                <v-col cols="12" sm="12" lg="12">
                    <h1 class="font-weight-bold text-center">The Best Partner You’ll Ever Have</h1>
                </v-col>
            </v-row>
            <v-row align="center" justify="center" class="mt-4">
                <v-col cols="12" sm="12" lg="4">
                    <v-card min-height="200px">
                        <v-card-title class="font-weight-black subtitle-1">
                            Support & Training
                        </v-card-title>
                        <v-card-text>
                            <p>Phone, email, and live chat support from our experienced team whenever you need help</p>
                        </v-card-text>
                        <v-card-actions>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" lg="4">
                    <v-card min-height="200px">
                        <v-card-title class="font-weight-black subtitle-1">
                            Marketing Dashboard
                        </v-card-title>
                        <v-card-text>
                            <p>
                                Manage all your clients in one spot + get proven marketing assets to help you sell BizPro
                            </p>
                        </v-card-text>
                        <v-card-actions>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="12" lg="4">
                    <v-card min-height="200px">
                        <v-card-title class="font-weight-black subtitle-1">
                            Discounted Pricing
                        </v-card-title>
                        <v-card-text>
                            <p>
                                Exclusive 25% discount for partners + recurring monthly subscription revenue
                            </p>
                        </v-card-text>
                        <v-card-actions>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-img src="smile-bg-2.png" class="white--text align-start full-page-primary homepage-header-bg-wrap" height="auto" style="background-color: #39afe4 !important;">
            <v-container class="py-12">
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="12" lg="12">
                        <h1 class="text-center">Get Started Today</h1>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center" class="ma-5">
                    <v-col cols="12" sm="12" lg="6" class="text-center">
                        <v-btn color="green" dark x-large to="/register">Register Now</v-btn>
                        <p class="mt-6"> 1.888.303.6789 | support@upnetic.com</p>
                    </v-col>
                </v-row>
            </v-container>
        </v-img>
    </div>
</template>

<script>
    export default {
        name: 'home',
        data: () => ({
            compliances: [
                {
                    title: 'Training Requirement Compliance',
                    items: [
                        'State-mandated sexual harassment prevention trainings for CA, CT, NY, and NYC',
                        'Certificates of completion',
                        'Training renewal reminders'
                    ],
                    color: 'green-arrow'
                },
                {
                    title: 'A Turnkey Training Program',
                    items: [
                        'Create a custom training program',
                        'Top courses: Harassment Prevention, Safety, OSHA for Employers, and more',
                        'One subscription for the whole company (up to 100 employees)'
                    ],
                    color: 'purple-arrow'
                },
                {
                    title: 'Detailed Recordkeeping',
                    items: [
                        'Track training progress',
                        'Save all training records',
                        'View quiz results on each lesson'
                    ],
                    color: 'blue-arrow'
                }
            ]
        }),
        mounted(){

        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if( vm.currentUserID ){

                    if( vm.isSuperAdmin || vm.isAdmin ){
                        vm.$router.push( '/firms' )
                    } else {
                        vm.$router.push( '/clients' )
                    }

                }
            })
        }
    }
</script>

<style>
.homepage-header-bg-wrap > .v-responsive__sizer {
    padding-bottom: 5% !important;
}
</style>
<style scoped>
.compliance .fa-li {
    margin-top: 5px;
}
ul.compliance {
    padding-left: 5px;
}

ul.compliance li{
    list-style: none;
    padding:5px;
}

ul.compliance li i{
    position:absolute;
    left:0;
}
ul.compliance{
    padding-left:15px;
    position:relative;
}
ul.compliance li i.green-arrow {
    color:#66be67;
}
ul.compliance li i.purple-arrow {
    color:#53509f
}
ul.compliance li i.blue-arrow {
    color:#39afe4;
}
</style>